import React from 'react';
import styled from 'styled-components';
import { closeModal, openModal } from '../ducks';
import { connect } from 'react-redux';
import ServicePlanScreenContent from '../../../components/software_licence/service_plan_screen_content';
import { buildLicenseGroups } from '../../../utils/software-licenses';
import I10n from '../../i10n';
import MsxIcons from '../../msx-icons';
import Button from '../../../atoms/button';
import { getSizedServicePlans } from '../../screens/service_plan_screen/ducks';
import Skeleton from '../../../components/skeleton';

const Container = styled.div`
  display: flex;
  flex: 1 1 0px;
  flex-direction: column;
  position: relative;
  overflow-y: auto;
  padding-bottom: 10px;
`;

const MobilePackageSummaryWrapper = styled.div`
  display: none;
  padding: 10px;
  justify-content: space-between;
  align-items: center;
  background-color: #FFFFFF;
  cursor: pointer;

  ${props => props.$isOpen ? '' : 'box-shadow: 0px 2px 16px 0px #00000040;'}

  @media (max-width: 800px) {
    display: flex;
  }
`;

const MobilePackageSupparyLabel = styled.span`
  font-size: 16px;
  font-weight: 400;
  color: #000000;
`;

const MobileChipAndIconWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const MobileIconWrapper = styled.div`
  transition: transform 0.3s;
  transform: ${(props) => (props.$isOpen ? "rotate(180deg)" : "rotate(0deg)")};
  margin-left: 10px;
  cursor: pointer;
`;

const Counter = styled.div`
  background-color: #2E3638;
  color: white;
  display: inline-block;
  line-height: 0px;
  border-radius: 50%;
  font-size: 16px;
  font-weight: 400;
`;

const CounterLabel = styled.div`
  display: inline-block;
  padding-top: 50%;
  padding-bottom: 50%;
  margin-left: 8px;
  margin-right: 8px;
`;

const NavigationButtonSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 10px 5px;
  border-top: 2px solid #EDEDED;
  background-color: white;
`;

const CancelWrapper = styled.div`
  margin-right: 10px;
`;

const SkeletonWrapper = styled.div`
  padding: 10px 20px;
`;

class ServicePlanScreen extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      servicePlansLoading: false,
      servicePlanItems: [],
      mobilePackageSummaryOpen: false
    };
  }

  loadServicePlans = () => {
    this.updateStateIfMounted({servicePlansLoading: true});
    getSizedServicePlans(this.props.softwareInfo.key, this.props.licenseModel, this.props.softwareLicences).then(response => {
      this.updateStateIfMounted({servicePlanItems: response});
    }).finally(() => {
      this.updateStateIfMounted({servicePlansLoading: false});
    });
  }

  componentDidMount = () => {
    this._isMounted = true;
    this.loadServicePlans();
  }

  componentWillUnmount = () => {
    this._isMounted = false;
  }

  updateStateIfMounted(state) {
    if (this._isMounted) {
      this.setState(state);
    }
  }


  removeSoftwareLicence = (licence, cancelCallback) => {

    this.props.openModal({
      modalType: 'confirmation',
      modalProps: {
        onCancel: () => { if (cancelCallback) { cancelCallback(); } this.props.closeModal(); },
        onSubmit: () => {
          this.props.closeModal();
          this.props.removeSoftwareLicence(licence);
        },
        title: I10n.get('screen.licence_selector.remove_licence.modal.title'),
        text: I10n.get('screen.licence_selector.remove_licence.modal.body'),
        cancelText: I10n.get('app.action.cancel'),
        submitText: I10n.get('app.action.continue'),
      }
    });
  }

  renderNavigationButtonSection = () => {
    return (
      <NavigationButtonSection>
        <CancelWrapper>
          <Button
            id='service-plan-screen-back-button'
            disabled={this.props.isSaving}
            onClick={event => {
              this.props.onPrevious();
            }}
          >
            {I10n.get('app.action.back')}
          </Button>
        </CancelWrapper>
        <Button
          importance="emphasized"
          primary
          disabled={this.props.isSaving}
          onClick={event => {
            this.props.onContinue();
          }}>
            {I10n.get('app.action.continue')}
        </Button>
      </NavigationButtonSection>
    );
  }

  render() {
    const canRemove = [...this.props.softwareLicences].length > 1;
    const licensesToShow = [...this.props.softwareLicences]
      .map(license => {return {
          ...license,
          canRemove,
          quantityLabel: I10n.get('bom.qty')
        };
      })
      .sort((a,b) => a.order - b.order);

    if (this.props.servicePlanActivated) {
      licensesToShow.push(...[...this.state.servicePlanItems].map(servicePlanItem => {
        return {
          ...servicePlanItem,
          quantityLabel: I10n.get('bom.service_plan_size'),
          ignoreGlobalQuantity: true
        };
      }));
    }

    const licenseGroupsForSummary = buildLicenseGroups(licensesToShow.sort((a,b) => a.order - b.order));
    const nbLicensesAdded = licenseGroupsForSummary.flatMap(licenseGroup => {
     return licenseGroup.licences.map(license => license);
    })
      .filter(licence => licence.ignoreGlobalQuantity == null || licence.ignoreGlobalQuantity === false)
      .reduce((accumulator, license) => {
        return accumulator + license.quantity;
      }, 0);

    return (
      <>
        {this.state.servicePlansLoading ? (
          <SkeletonWrapper>
            <Skeleton nbCols={2} expand={true}></Skeleton>
          </SkeletonWrapper>
        ) :
        <>
          <MobilePackageSummaryWrapper $isOpen={this.state.mobilePackageSummaryOpen} onClick={() => {
            this.updateStateIfMounted({mobilePackageSummaryOpen: !this.state.mobilePackageSummaryOpen});
          }}>
            <MobilePackageSupparyLabel>{I10n.get("screen.licence_selector.package_summary")}</MobilePackageSupparyLabel>
            <MobileChipAndIconWrapper>
              <Counter><CounterLabel>{nbLicensesAdded >= 100 ? '99+' : nbLicensesAdded }</CounterLabel></Counter>
              <MobileIconWrapper $isOpen={this.state.mobilePackageSummaryOpen}>
                <MsxIcons name="down-arrow"></MsxIcons>
              </MobileIconWrapper>
            </MobileChipAndIconWrapper>
          </MobilePackageSummaryWrapper>
          <Container>
            <ServicePlanScreenContent
              softwareInfo={this.props.softwareInfo}
              licenseModel={this.props.licenseModel}
              servicePlanItems={this.state.servicePlanItems}
              servicePlanActivated={this.props.servicePlanActivated}
              licenseGroupsForSummary={licenseGroupsForSummary}
              setServicePlanActivationServicePlanScreen={(newStatus) => {
                return this.props.setServicePlanActivation(newStatus);
              }}
              removeSoftwareLicence={(license, cancelCallback) => {
                this.props.openModal({
                  modalType: 'confirmation',
                  modalProps: {
                    onCancel: () => { if (cancelCallback) { cancelCallback(); } this.props.closeModal(); },
                    onSubmit: () => {
                      this.props.closeModal();
                      this.props.removeSoftwareLicence(license);
                    },
                    title: I10n.get('screen.licence_selector.remove_licence.modal.title'),
                    text: I10n.get('screen.licence_selector.remove_licence.modal.body'),
                    cancelText: I10n.get('app.action.cancel'),
                    submitText: I10n.get('app.action.continue'),
                  }
                });
              }}
              clearSoftwareLicenses={() => {
                return this.props.clearSoftwareLicenses();
              }}
              openModal={this.props.openModal}
              closeModal={this.props.closeModal}
              onContinue={() => {
                this.props.closeModal();
              }}
              mobilePackageSummaryOpen={this.state.mobilePackageSummaryOpen}
              isSaving={this.props.configurationSaver.isSaving}
            ></ServicePlanScreenContent>
          </Container>
          {this.renderNavigationButtonSection()}
        </>}
      </>
    );
  }
}

const mapStateToProps = state => {
  return state;
};

const mapDispatchToProps = dispatch => {
  return {
    openModal: (modalTypeWithProps) => dispatch(openModal(modalTypeWithProps)),
    closeModal: () => dispatch(closeModal())
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ServicePlanScreen);
